import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en.json'
import no from './locales/no.json'

// Bokmål is canonical; English fallback so missing keys surface as English copy
// rather than the raw key. Every user-facing string must exist in BOTH dictionaries.
export const SUPPORTED_LANGUAGES = ['no', 'en'] as const
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number]

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      no: { translation: no },
      en: { translation: en },
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    detection: {
      // ?lang=xx is the dev affordance for verifying translations without touching browser settings.
      order: ['querystring', 'localStorage', 'navigator', 'htmlTag'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'polf-admin-lang',
      caches: ['localStorage'],
    },
    interpolation: {
      // React already escapes — i18next double-escaping mangles `<` etc.
      escapeValue: false,
    },
    returnNull: false,
  })

export default i18next
